/* Customization:
- Updated state label with macrocategoria Bando variation
*/

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Icon } from 'design-comuni-plone-theme/components/ItaliaTheme';

/**
 * PageHeaderBando view component class.
 * @function PageHeaderBando
 * @params {object} content: Content object.
 * @returns {string} Markup of the component.
 */

const messages = defineMessages({
  bando: {
    id: 'Bando',
    defaultMessage: 'Bando',
  },
  update_note_bando: {
    id: 'update_note_bando',
    defaultMessage: 'Note di aggiornamento',
  },
  open: {
    id: 'bando_open',
    defaultMessage: 'attivo',
  },
  closed_bando: {
    id: 'closed_bando',
    defaultMessage: 'chiuso',
  },
  closed_avviso: {
    id: 'closed_avviso',
    defaultMessage: 'scaduto',
  },
  inProgress: {
    id: 'bando_inProgress',
    defaultMessage: 'in corso',
  },
  scheduled: {
    id: 'bando_scheduled',
    defaultMessage: 'programmato',
  },
});

const PageHeaderBando = ({ content }) => {
  const intl = useIntl();

  return content['@type'] === 'Bando' ? (
    <>
      {/* Note di aggiornamento */}
      {content?.update_note && (
        <p>
          <strong>{intl.formatMessage(messages.update_note_bando)}:</strong>{' '}
          {content.update_note}
        </p>
      )}

      {/* Bando state */}
      {content?.bando_state && (
        <div
          className={cx(
            'genericcard card card-teaser shadow p-3 mt-3 rounded bando_state',
            content.bando_state[0],
          )}
        >
          <div className="card-body">
            <div className="card-text">
              <Icon
                className="mr-2"
                color=""
                icon={
                  {
                    open: 'it-check-circle',
                    closed: 'it-error',
                    inProgress: 'it-info-circle',
                    scheduled: 'it-calendar',
                  }[content.bando_state[0]]
                }
                padding={false}
                size=""
              />
              {content?.macro_categoria?.title
                ? content.macro_categoria.title
                : intl.formatMessage(messages.bando)}{' '}
              {content.bando_state[1]}
            </div>
          </div>
        </div>
      )}
    </>
  ) : null;
};

export default PageHeaderBando;

PageHeaderBando.propTypes = {
  params: PropTypes.shape({
    content: PropTypes.object,
    readingtime: PropTypes.string,
    showreadingtime: PropTypes.bool,
    imageinheader: PropTypes.bool,
    imageinheader_field: PropTypes.string,
    showdates: PropTypes.bool,
    showtassonomiaargomenti: PropTypes.bool,
  }),
};
